// Multivariate Dependencies
import React from 'react';
// Components
import MaterialAvatar from '@material-ui/core/Avatar';
// Types
import { AvatarSize } from '../types/AvatarProps';
// Styles
import { useAvatarStyles } from '../styles/useAvatarStyles';
/**
 * @deprecated Do not use legacy components anymore.
 */
export var Avatar = function (props) {
    var name = props.name, initials = props.initials, image = props.image;
    var classes = useAvatarStyles(props);
    return (React.createElement(MaterialAvatar, { alt: name, src: image, className: "".concat(classes.avatar, " avatar") }, initials));
};
Avatar.defaultProps = {
    size: AvatarSize.Medium,
};
//# sourceMappingURL=Avatar.js.map